import { useMemo } from 'react';
import { useLingui } from '@lingui/react/macro';

const BASE_ASSET_URL = 'https://static.elfsight.com/icons';

export const usePresetTags = () => {
  const { t } = useLingui();

  return useMemo(
    () => [
      {
        title: t`Accessibility`,
        items: [
          {
            id: 'e0146319-8f40-484b-8dac-c4cb205bef6e',
            type: 'preset',
            name: t`Wheelchair Accessible`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-wheelchair-accessible.svg`
            }
          },
          {
            id: '2a7a94ec-3fc5-4b59-a3bd-57fcf108a2ec',
            type: 'preset',
            name: t`Accessible Restroom`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-accessible-restroom.svg`
            }
          },
          {
            id: 'bfc64e13-010b-4331-9fd7-f9d39aaa16e1',
            type: 'preset',
            name: t`Elevator Available`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-elevator-available.svg`
            }
          }
        ]
      },
      {
        title: t`Booking`,
        items: [
          {
            id: 'd292d6b1-f967-4a90-bbe8-6926228c7960',
            type: 'preset',
            name: t`Free cancellation`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-free-cancellation.svg`
            }
          },
          {
            id: 'f460116a-5381-4871-ad4f-948b914f2849',
            type: 'preset',
            name: t`By Appointment Only`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-by-appointment-only.svg`
            }
          },
          {
            id: 'c865f5e4-df83-48be-8256-cea76b402b6c',
            type: 'preset',
            name: t`Online Booking Available`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-online-booking-available.svg`
            }
          },
          {
            id: '75df0b0d-7621-471a-90f9-879a1269efcb',
            type: 'preset',
            name: t`Same-Day Appointments`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-same-day-appointments.svg`
            }
          }
        ]
      },
      {
        title: t`Dining Options`,
        items: [
          {
            id: '2add761b-2f4b-4dd2-90de-d37393a89ca8',
            type: 'preset',
            name: t`Dine-In`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-dine-in.svg`
            }
          },
          {
            id: 'fdd8c1bb-3ffe-4831-a9bf-b2eef2cda531',
            type: 'preset',
            name: t`Takeaway`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-takeaway.svg`
            }
          },
          {
            id: '10f9c994-b691-41ce-a5c0-3af9a1b41efe',
            type: 'preset',
            name: t`Delivery`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-delivery.svg`
            }
          },
          {
            id: '6ca23d33-cba4-47a5-9dcc-b1e2e5967cb1',
            type: 'preset',
            name: t`Outdoor Seating`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-outdoor-seating.svg`
            }
          },
          {
            id: '26021efe-edae-4aed-83fc-16a4981c7a1b',
            type: 'preset',
            name: t`Reservations Accepted`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-reservations-accepted.svg`
            }
          }
        ]
      },
      {
        title: t`Facilities`,
        items: [
          {
            id: '9af0dc3c-b61e-4941-8754-49917b2d160f',
            type: 'preset',
            name: t`Free Wi-Fi`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-free-wi-fi.svg`
            }
          },
          {
            id: 'cbe15ec0-b7ed-43d9-914b-10730f462ed2',
            type: 'preset',
            name: t`Restroom Available`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-restroom-available.svg`
            }
          },
          {
            id: 'ee092670-e439-4340-bbbd-a491870d1b39',
            type: 'preset',
            name: t`Fitting Rooms`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-fitting-rooms.svg`
            }
          },
          {
            id: '8bbbd0a4-2d64-4aa0-9486-d871601e059f',
            type: 'preset',
            name: t`Air Conditioning`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-air-conditioning.svg`
            }
          },
          {
            id: '3021f61f-bf61-4cfe-a2fc-5b65bba08d0c',
            type: 'preset',
            name: t`Pet Friendly`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-pet-friendly.svg`
            }
          }
        ]
      },
      {
        title: t`Health & Safety`,
        items: [
          {
            id: '6c27452f-f636-45f4-a54f-63a1c74dc24f',
            type: 'preset',
            name: t`Masks Required`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-masks-required.svg`
            }
          },
          {
            id: '9e5b3e24-7b1f-441f-8c89-f9edefcafffd',
            type: 'preset',
            name: t`Hand Sanitizer Provided`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-hand-sanitizer-provided.svg`
            }
          },
          {
            id: '464e04ed-b5b2-4903-804f-6c2f4657ab9b',
            type: 'preset',
            name: t`Temperature Check`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-temperature-check.svg`
            }
          },
          {
            id: '32719b06-6132-4487-bda6-c6613250a5ed',
            type: 'preset',
            name: t`Social Distancing`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-social-distancing.svg`
            }
          }
        ]
      },
      {
        title: t`Kids & Family`,
        items: [
          {
            id: '973a7ad8-92f5-4273-8a3e-a26db5a2fbe2',
            type: 'preset',
            name: t`Family Friendly`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-family-friendly.svg`
            }
          },
          {
            id: '5935a79d-cbac-4baa-9b7c-2da568e04ee0',
            type: 'preset',
            name: t`Kids Area`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-kids-area.svg`
            }
          },
          {
            id: 'ed87cbd3-2340-4999-a565-6716850cd0f6',
            type: 'preset',
            name: t`Kids Menu`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-kids-menu.svg`
            }
          },
          {
            id: '92663a2c-1bc0-45eb-827e-f7a5d980135b',
            type: 'preset',
            name: t`Baby Changing Table`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-baby-changing-table.svg`
            }
          },
          {
            id: 'b1e53a47-7fa8-42a1-8b0e-86d073dd8bf5',
            type: 'preset',
            name: t`High Chairs Available`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-high-chairs-available.svg`
            }
          }
        ]
      },
      {
        title: t`Location`,
        items: [
          {
            id: '744d2a4b-2275-4450-a105-7df2cf878278',
            type: 'preset',
            name: t`City Center`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-city-center.svg`
            }
          },
          {
            id: 'b44e0108-a5b9-4e60-8c2c-075aae397ec6',
            type: 'preset',
            name: t`Near Metro Station`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-near-metro-station.svg`
            }
          },
          {
            id: '9317a404-0e5a-4cce-aac8-5aade43e463d',
            type: 'preset',
            name: t`Near Bus Stop`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-near-bus-stop.svg`
            }
          },
          {
            id: '37bb89d1-d6dd-4255-83cf-9dcb9bf6773f',
            type: 'preset',
            name: t`Near Airport`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-near-airport.svg`
            }
          },
          {
            id: 'cdfa288c-e8e1-4b16-9f78-b77bafee89d1',
            type: 'preset',
            name: t`Shuttle Available`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-shuttle-available.svg`
            }
          }
        ]
      },
      {
        title: t`Music`,
        items: [
          {
            id: '63a1ddf1-9888-4f68-a761-4e7fac05235f',
            type: 'preset',
            name: t`Live Music`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-live-music.svg`
            }
          },
          {
            id: '572b2931-96fc-40bd-8fef-c8dfddd55f87',
            type: 'preset',
            name: t`Dj Events`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-dj-events.svg`
            }
          }
        ]
      },
      {
        title: t`Opening Hours`,
        items: [
          {
            id: 'af60bbf5-2bb8-42b0-a4a9-0bfe0e4832f9',
            type: 'preset',
            name: t`Open 24/7`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-fullday-open.svg`
            }
          },
          {
            id: '859d5fac-0c72-4938-b812-1905c6ef0c8e',
            type: 'preset',
            name: t`Open Late`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-open-late.svg`
            }
          },
          {
            id: 'f49dcdf7-7d9c-4f9b-9637-d8486f49bb79',
            type: 'preset',
            name: t`Open on Weekends`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-open-on-weekends.svg`
            }
          }
        ]
      },
      {
        title: t`Parking`,
        items: [
          {
            id: '7114c891-2a67-41aa-9737-5e19b4067703',
            type: 'preset',
            name: t`Free Parking`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-free-parking.svg`
            }
          },
          {
            id: 'f54b4743-1064-46b9-97e8-54089eef8814',
            type: 'preset',
            name: t`Paid Parking`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-paid-parking.svg`
            }
          },
          {
            id: '19a2d074-dce7-4fe4-8c51-789881d48ddd',
            type: 'preset',
            name: t`Street Parking`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-street-parking.svg`
            }
          },
          {
            id: '3438e552-9af1-4b5e-847a-e1af799d7026',
            type: 'preset',
            name: t`Bike Parking`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-bike-parking.svg`
            }
          },
          {
            id: '99640b23-2ec9-42f0-9824-3aa860af2aac',
            type: 'preset',
            name: t`EV Charging Available`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-ev-charging-available.svg`
            }
          }
        ]
      },
      {
        title: t`Shopping`,
        items: [
          {
            id: '24c82d9c-01da-4b61-bc74-ac2953d8577e',
            type: 'preset',
            name: t`Credit Cards Accepted`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-credit-cards-accepted.svg`
            }
          },
          {
            id: 'f9b866fe-ff0b-4d5d-975e-f3ce09dd3ff3',
            type: 'preset',
            name: t`Cash Only`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-cash-only.svg`
            }
          },
          {
            id: 'dac37992-18f8-481e-8a1f-c8edba505366',
            type: 'preset',
            name: t`Sale`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-sale.svg`
            }
          },
          {
            id: 'fca3b284-5d7b-4ece-aa50-50802989d76e',
            type: 'preset',
            name: t`New Arrivals`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-new-arrivals.svg`
            }
          },
          {
            id: '939257c2-466b-42c0-8887-4ae23d727eb0',
            type: 'preset',
            name: t`Limited-Time Offer`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-limited-time-offer.svg`
            }
          },
          {
            id: '3070aa60-7eb3-4432-ad16-6bf700a33ad6',
            type: 'preset',
            name: t`Exclusive In-Store Deal`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-exclusive-in-store-deal.svg`
            }
          },
          {
            id: '66e5fc1c-78f4-4a8f-9b2c-869feded5640',
            type: 'preset',
            name: t`Tax-Free Shopping`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-tax-free-shopping.svg`
            }
          },
          {
            id: '2cab2ef9-0912-4e16-836f-d0929a5943f7',
            type: 'preset',
            name: t`Returns Accepted`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-returns-accepted.svg`
            }
          }
        ]
      },
      {
        title: t`Sustainability`,
        items: [
          {
            id: 'e06974e5-3f34-4dea-9d7f-cfb3dbaeddfa',
            type: 'preset',
            name: t`Eco-Friendly`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-eco-friendly.svg`
            }
          },
          {
            id: 'e4d3605f-408c-4e9b-95fa-98b5e12b369f',
            type: 'preset',
            name: t`Recycling Available`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-recycling-available.svg`
            }
          },
          {
            id: '9f6ea8f9-77a2-42e7-898e-b6257c0b2c7f',
            type: 'preset',
            name: t`Local Products`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-local-products.svg`
            }
          },
          {
            id: 'd8b9fbb6-048f-49b5-80b3-6ee67b139e14',
            type: 'preset',
            name: t`Plastic-Free`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-plastic-free.svg`
            }
          }
        ]
      },
      {
        title: t`Other`,
        items: [
          {
            id: '47919fc5-e970-4035-93df-66e62307f535',
            type: 'preset',
            name: t`Flagship Location`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-flagship-store.svg`
            }
          },
          {
            id: 'e79eeac9-d05f-44ad-b4b8-a3207367d50b',
            type: 'preset',
            name: t`Invite Only`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-invite-only.svg`
            }
          },
          {
            id: '6e5248c8-4bea-4bd8-8fb8-800edb5370fc',
            type: 'preset',
            name: t`Seasonal Availability`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-seasonal-availability.svg`
            }
          },
          {
            id: '147980bd-ea09-4904-9822-19cc5daa7fa3',
            type: 'preset',
            name: t`Grand Opening`,
            icon: {
              url: `${BASE_ASSET_URL}/configurator-store-locator-tags-grand-opening.svg`
            }
          }
        ]
      }
    ],
    [t]
  );
};

export const presetTagKeysToIgnore = [
  'Accessibility',
  'Wheelchair Accessible',
  'Accessible Restroom',
  'Elevator Available',

  'Booking',
  'Free cancellation',
  'By Appointment Only',
  'Online Booking Available',
  'Same-Day Appointments',

  'Dining Options',
  'Dine-In',
  'Takeaway',
  'Delivery',
  'Outdoor Seating',
  'Reservations Accepted',

  'Facilities',
  'Free Wi-Fi',
  'Restroom Available',
  'Fitting Rooms',
  'Air Conditioning',
  'Pet Friendly',

  'Health & Safety',
  'Masks Required',
  'Hand Sanitizer Provided',
  'Temperature Check',
  'Social Distancing',

  'Kids & Family',
  'Family Friendly',
  'Kids Area',
  'Kids Menu',
  'Baby Changing Table',
  'High Chairs Available',

  'Location',
  'City Center',
  'Near Metro Station',
  'Near Bus Stop',
  'Near Airport',
  'Shuttle Available',

  'Music',
  'Live Music',
  'Dj Events',

  'Opening Hours',
  'Open 24/7',
  'Open Late',
  'Open on Weekends',

  'Parking',
  'Free Parking',
  'Paid Parking',
  'Street Parking',
  'Bike Parking',
  'EV Charging Available',

  'Shopping',
  'Credit Cards Accepted',
  'Cash Only',
  'Sale',
  'New Arrivals',
  'Limited-Time Offer',
  'Exclusive In-Store Deal',
  'Tax-Free Shopping',
  'Returns Accepted',

  'Sustainability',
  'Eco-Friendly',
  'Recycling Available',
  'Local Products',
  'Plastic-Free',

  'Other',
  'Flagship Location',
  'Invite Only',
  'Seasonal Availability',
  'Grand Opening'
];
